/* eslint-disable sort-keys */
/* eslint-disable @typescript-eslint/naming-convention */
import { ExecutionResult } from '@lcs/shared/api';
import { ClosedExceptionInput, ScheduleDetailInput, ScheduleInput } from 'generated/graphql-types';
import {
   ClosedExceptionItemView,
   closedExceptionFields,
} from 'src/app/pages/closed-exceptions/models/closed-exceptions.model';
import { ScheduleDetailSaveModel } from 'src/app/pages/schedule-details/models/schedule-detail-save.model';
import { SaveSchedule } from 'src/app/pages/schedule-details/queries/generated/SaveSchedule';
import { ScheduleHourItemView, scheduleHourFields } from 'src/app/pages/schedule-hours/models/schedule-hours.model';

export function createScheduleInput(
   scheduleSave: ScheduleDetailSaveModel,
   scheduleFields: (keyof ScheduleInput)[]
): ScheduleInput {
   scheduleFields = [...scheduleFields, 'scheduleId'];
   const scheduleDetailFieldIndex = scheduleFields.indexOf('scheduleDetails');
   if (scheduleDetailFieldIndex !== -1) {
      scheduleFields.splice(scheduleDetailFieldIndex, 1);
      formatScheduleHouFields(scheduleFields, 'scheduleDetails', scheduleHourFields);
   }
   const closedExceptionsFieldIndex = scheduleFields.indexOf('closedExceptions');
   if (closedExceptionsFieldIndex !== -1) {
      scheduleFields.splice(closedExceptionsFieldIndex, 1);
      formatClosedExceptionFields(scheduleFields, 'closedExceptions', closedExceptionFields);
   }
   const scheduleInput: ScheduleInput = {
      closedExceptions: scheduleSave.closedExceptions
         ?.filter((key) => {
            return !key.isDeleted;
         })
         .map((schedule) => {
            return {
               closedExceptionId: schedule.closedExceptionId,
               endDate: schedule.endDate,
               endTime: schedule.endTime,
               fields: [],
               promptId: schedule.prompt?.promptId,
               scheduleId: scheduleSave.scheduleId,
               startDate: schedule.startDate,
               startTime: schedule.startTime,
            };
         }),
      description: scheduleSave.description,
      fields: scheduleFields,
      name: scheduleSave.name,
      scheduleDetails: scheduleSave.scheduleHours
         ?.filter((key) => {
            return !key.isDeleted;
         })
         .map((schedule) => {
            return {
               closeTime: schedule.closeTime,
               dayOfWeek: schedule.dayOfWeek,
               fields: [],
               openTime: schedule.openTime,
               scheduleDetailId: schedule.scheduleDetailId,
               scheduleId: scheduleSave.scheduleId,
            };
         }),
      scheduleId: scheduleSave.scheduleId,
   };

   scheduleFields.forEach((field) => {
      scheduleInput[field.toString()] = scheduleSave[field];
   });
   return scheduleInput;
}

export function getDeletedScheduleHourIds(routes: ScheduleHourItemView[]): number[] {
   return (
      routes.reduce((acc, key) => {
         if (key.isDeleted && key.scheduleDetailId > 0) {
            acc.push(key.scheduleDetailId);
         }
         return acc;
      }, [] as number[]) ?? []
   );
}

export function convertDayOfWeekToNumber(dayOfWeek: string): number | null {
   const mapping: { [key: string]: number } = {
      Sun: 1,
      Sunday: 1,
      Mon: 2,
      Monday: 2,
      Tue: 3,
      Tuesday: 3,
      Wed: 4,
      Wednesday: 4,
      Thu: 5,
      Thursday: 5,
      Fri: 6,
      Friday: 6,
      Sat: 7,
      Saturday: 7,
   };

   return mapping[dayOfWeek] || null;
}

export function getDeletedClosedExceptionIds(routes: ClosedExceptionItemView[]): number[] {
   return (
      routes.reduce((acc, key) => {
         if (key.isDeleted && key.closedExceptionId > 0) {
            acc.push(key.closedExceptionId);
         }
         return acc;
      }, [] as number[]) ?? []
   );
}

type ScheduleEmbedFieldScheduleHour = keyof ScheduleDetailInput;

function formatScheduleHouFields(fields: string[], key: string, embedFields: ScheduleEmbedFieldScheduleHour[]) {
   if (key) {
      for (const embedField of embedFields) {
         fields.push(`${key}.${embedField}`);
      }
   }
}

type ScheduleEmbedFieldClosedException = keyof ClosedExceptionInput;

function formatClosedExceptionFields(fields: string[], key: string, embedFields: ScheduleEmbedFieldClosedException[]) {
   if (key) {
      for (const embedField of embedFields) {
         fields.push(`${key}.${embedField}`);
      }
   }
}
export type ScheduleSaveResult = ExecutionResult<SaveSchedule>;
